import { createAction } from '@reduxjs/toolkit';
import { IGetMeetingSuccessPayload, IMeetingsState } from '@store/meetings/types';
import { uniqBy } from 'lodash';

export class GetMyMeetingsSuccess {
  static get action() {
    return createAction<IGetMeetingSuccessPayload>('meetings/GET_MY_MEETINGS_SUCCESS');
  }

  static get reducer() {
    return (draft: IMeetingsState, { payload }: ReturnType<typeof GetMyMeetingsSuccess.action>) => {
      const { data, hasMore, initializedByScroll } = payload;

      draft.requests.getMeetingsPending = false;
      draft.myMeetings.hasMore = hasMore;
      draft.myMeetings.meetingList = uniqBy(
        initializedByScroll ? [...draft.myMeetings.meetingList, ...data] : data,
        'id',
      );

      return draft;
    };
  }
}
